import React from "react";
import HDIWCommon from "../Common/HDIWCommon";
import wl from "../../Assets/waveLeft.png";
import wr from "../../Assets/waveright.png";
import spu from "../../Assets/ShopLable.jpeg";
import pd from "../../Assets/PackingAndDelivery.jpeg";
import spt from "../../Assets/sorting_pre_treatment.jpeg";
import wst from "../../Assets/washing_specialized_treatments.jpeg";
import { motion } from "framer-motion";
export default function HowDoesItWorks() {
  const detailsdata = {
    first: {
      src1: spu,
      title1: "Schedule a Pick-Up",
      desc1:
        "Click on the Schedule Delivery button at the top right, fill in the details, and proceed to WhatsApp. Just hit send, and our team will handle the rest! With flexible scheduling, we pick up your laundry at your convenience, right at your doorstep.",
    },
    second: {
      src2: spt,
      title2: "Sorting & Pre Treatment",
      desc2:
        "Our experts meticulously sort and inspect each piece for specific stains and materials, ensuring that every item receives tailored care. From delicate fabrics to everyday wear, our pre-treatment process guarantees optimal cleanliness and protection.",
    },
    third: {
      src3: wst,
      title3: "Washing & Specialized Treatments",
      desc3:
        "We use high-efficiency washers with custom settings for each fabric type. Our exclusive, non-toxic in-house detergents ensure a deep clean without any harsh chemicals. Each item receives special attention, whether it’s a wash-and-fold or delicate dry cleaning.",
    },
    forth: {
      src4: pd,
      title4: "Packaging & Delivery",
      desc4:
        "Once your laundry is perfectly clean and fresh, our team carefully folds or hangs each item to prevent creasing. We pack everything with care and deliver it to your doorstep, exactly when you expect it. From start to finish, we bring convenience and quality to you.",
    },
  };
  return (
    <div className="flex flex-col items-center relative -top-[170px] md:-top-[100px] px-8 md:px-20">
      <motion.div
        initial="hidden"
        whileInView="visible"
        // viewport={{ once: true }}
        transition={{ delay: 0.4, duration: 1 }}
        className="md:flex md:justify-around md:items-center"
      >
        <div>
          <img src={wl} alt="waves" className="hidden md:flex" />
        </div>
        <p className="text-[36px] md:text-[64px] text-center font-[700] text-white pb-9 md:py-8">
          How Does It Works?
        </p>
        <div>
          <img src={wr} alt="waves" className="hidden md:flex" />
        </div>
      </motion.div>
      <div className="grid md:grid-cols-4 gap-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 1 }}
          variants={{
            visible: { x: 10, opacity: 1 },
            hidden: { x: -10, opacity: 0 },
          }}
          className="md:col-start-1 md:col-end-4"
        >
          <HDIWCommon
            src={detailsdata.first.src1}
            title={detailsdata.first.title1}
            desc={detailsdata.first.desc1}
          />
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 1 }}
          variants={{
            visible: { x: -10, opacity: 1 },
            hidden: { x: 10, opacity: 0 },
          }}
          className="md:col-start-2 md:col-end-5"
        >
          <HDIWCommon
            src={detailsdata.second.src2}
            title={detailsdata.second.title2}
            desc={detailsdata.second.desc2}
          />
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 1 }}
          variants={{
            visible: { x: 10, opacity: 1 },
            hidden: { x: -10, opacity: 0 },
          }}
          className="md:col-start-1 md:col-end-4"
        >
          <HDIWCommon
            src={detailsdata.third.src3}
            title={detailsdata.third.title3}
            desc={detailsdata.third.desc3}
          />
        </motion.div>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 1 }}
          variants={{
            visible: { x: -10, opacity: 1 },
            hidden: { x: 10, opacity: 0 },
          }}
          className="md:col-start-2 md:col-end-5 mb-8"
        >
          <HDIWCommon
            src={detailsdata.forth.src4}
            title={detailsdata.forth.title4}
            desc={detailsdata.forth.desc4}
          />
        </motion.div>
      </div>
    </div>
  );
}
